import type { Action } from 'state/actions';

import type { DiscoverPageState, LifeCycleCategory, LifeCycleSection } from './page.model';
import { initialDiscoverPageState } from './page.model';

export function dicoverPageReducer(
  state: DiscoverPageState = initialDiscoverPageState,
  action: Action,
): DiscoverPageState {
  switch (action.type) {
    case 'DISCOVER_REGION_CHANGED':
      return { ...state, region: action.region };
    case 'POST_TRADE_TAB_CHANGED':
      return { ...state, selectedPostTradeTab: action.tabId };
    case 'RUBRIC_TYPE_CHANGED':
      return { ...state, selectedRubricTab: action.rubricType };
    case 'RUBRIC_PERIOD_CHANGED':
      return { ...state, selectedPeriod: action.period };
    case 'LIFECYCLE_SELECTED_SECTION_CHANGED':
      return { ...state, selectedSection: action.category };
    case 'LIFECYCLE_SIZE_CHANGED':
      return {
        ...state,
        lifeCycleSections: updateLifecycleSection(state.lifeCycleSections, action.category, s => ({
          ...s,
          pagination: { ...s.pagination, pageSize: action.size },
        })),
      };
    case 'LIFECYCLE_PAGINATION_CHANGED':
      return {
        ...state,
        lifeCycleSections: updateLifecycleSection(state.lifeCycleSections, action.category, s => ({
          ...s,
          pagination: action.pagination,
        })),
      };
    case 'LIFECYCLE_PAGE_CHANGED':
      return {
        ...state,
        lifeCycleSections: updateLifecycleSection(state.lifeCycleSections, action.category, s => ({
          ...s,
          pagination: { ...s.pagination, pageNumber: action.page },
        })),
      };
    case 'LIFECYCLE_SIZE_AND_PAGE_CHANGED':
      return {
        ...state,
        lifeCycleSections: updateLifecycleSection(state.lifeCycleSections, action.category, s => ({
          ...s,
          pagination: { ...s.pagination, pageNumber: action.page, pageSize: action.size },
        })),
      };
    default:
      return state;
  }
}

function updateLifecycleSection(
  sections: LifeCycleSection[],
  category: LifeCycleCategory,
  action: (section: LifeCycleSection) => LifeCycleSection,
): LifeCycleSection[] {
  return sections.map(s => {
    if (s.category === category) {
      return action(s);
    } else {
      return { ...s };
    }
  });
}
